import { toIsoDate } from "../src/lib/utils/formatters.js";

function round(value, digits = 2) {
  const factor = 10 ** digits;
  return Math.round(value * factor) / factor;
}

export function fallbackGoldPrice(reason = "Fallback-данные активны") {
  return {
    symbol: "XAUUSD",
    price: 4718.39,
    currency: "USD",
    timestamp: new Date().toISOString(),
    source: "Fallback",
    isFallback: true,
    error: reason,
  };
}

export function fallbackGoldHistory(range = "90d") {
  const days = range === "1y" ? 365 : range === "30d" ? 30 : 90;
  const startPrice = 4380;
  const today = new Date();
  return Array.from({ length: days }, (_, index) => {
    const date = new Date(today);
    date.setUTCDate(today.getUTCDate() - (days - index - 1));
    const wave = Math.sin(index / 6) * 32 + Math.cos(index / 13) * 48;
    const trend = index * 2.35;
    const close = round(startPrice + trend + wave);
    const open = round(close - Math.sin(index / 4) * 18);
    const high = round(Math.max(open, close) + 18 + Math.abs(Math.cos(index)) * 14);
    const low = round(Math.min(open, close) - 18 - Math.abs(Math.sin(index)) * 11);
    return {
      date: toIsoDate(date),
      open,
      high,
      low,
      close,
      price: close,
      volume: null,
    };
  });
}

export function fallbackMacro(missingFields = []) {
  return {
    usdIndex: 103.2,
    realYield: 1.82,
    tenYearYield: 4.45,
    fedRate: 5.25,
    inflation: 3.1,
    unemployment: 3.9,
    sp500: 5280,
    oil: 82.1,
    btc: 67200,
    source: "Fallback macro",
    isFallback: true,
    missingFields,
  };
}

export function fallbackNews(reason = "Fallback новостей активен") {
  const now = new Date().toISOString();
  return [
    {
      title: "Золото остается в фокусе перед важными данными США",
      source: "Fallback",
      url: "",
      publishedAt: now,
      summary:
        "Участники рынка следят за долларом США, доходностями США и инфляционными данными. Это только помощник анализа, не финансовая консультация.",
      rawText:
        "Gold market watches inflation, Federal Reserve expectations, dollar moves, treasury yields and safe haven demand.",
      sentiment: "unknown",
      impact: null,
      horizon: null,
      isFallback: true,
      error: reason,
    },
    {
      title: "Ожидания по ставкам и геополитические риски влияют на XAU/USD",
      source: "Fallback",
      url: "",
      publishedAt: now,
      summary:
        "Золото чувствительно реагирует на реальные доходности, силу доллара США и спрос на защитные активы.",
      rawText: "rate cut geopolitical risk safe haven lower real yields strong dollar higher yields",
      sentiment: "unknown",
      impact: null,
      horizon: null,
      isFallback: true,
      error: reason,
    },
  ];
}

export function fallbackCalendar(reason = "Fallback экономического календаря активен") {
  const eventDate = new Date();
  eventDate.setUTCHours(12, 30, 0, 0);
  return [
    {
      name: "US CPI",
      country: "US",
      time: eventDate.toISOString(),
      impact: "very high",
      previous: "3.1%",
      estimate: "3.0%",
      actual: null,
      goldRisk: "Возможна высокая волатильность, так как CPI меняет ожидания по ставкам.",
      source: "Fallback",
      isFallback: true,
      error: reason,
    },
  ];
}
